import { Box, Stack, Typography, Divider } from "@mui/material";

/*
 * A still of the real thing: one question, one answer, one number that matters.
 *
 * Shared by the landing page and the sign-in page, so the picture a visitor sees before
 * registering is the same one beside the form while they register. `compact` trims the
 * type and the bars for the narrower column next to the login card.
 */
export default function ChatMock({ compact = false }) {
    const f = compact ? 15 : 16.5;          // body type
    const bar = compact ? 7 : 9;            // bar height
    const rows = [
        { n: "Furnace 2", v: 4820, w: "100%" },
        { n: "Furnace 1", v: 3610, w: "75%" },
        { n: "Rolling Mill", v: 2140, w: "44%" },
    ];

    return (
        <Box sx={{
            p: compact ? 2.5 : { xs: 2.5, sm: 3 }, borderRadius: 4, width: "100%",
            bgcolor: "rgba(6,16,10,.78)",
            border: "1px solid rgba(255,255,255,.12)",
            boxShadow: "0 30px 80px rgba(0,0,0,.45)",
        }}>
            {/*
              * No window chrome. Three Mac dots said "this is a screenshot of an app",
              * which is neither true nor the point - the point is the answer.
              */}
            <Stack direction="row" spacing={1} sx={{ alignItems: "center", mb: 2.2 }}>
                <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#7BD95F" }} />
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,.55)", letterSpacing: .6, fontWeight: 600 }}>
                    ASK AI
                </Typography>
            </Stack>

            <Box sx={{
                ml: "auto", maxWidth: "88%", mb: 2.5,
                px: 2.5, py: 1.6, borderRadius: "16px 16px 5px 16px",
                bgcolor: "rgba(46,125,32,.85)", fontSize: f,
            }}>
                which machine used the most power in yesterday’s Shift A?
            </Box>

            <Box sx={{
                px: compact ? 2.2 : 3, py: compact ? 2 : 2.4,
                borderRadius: "16px 16px 16px 5px",
                bgcolor: "rgba(255,255,255,.07)", border: "1px solid rgba(255,255,255,.08)",
            }}>
                <Typography sx={{ fontSize: f, mb: 2 }}>
                    In yesterday’s Shift A (08:30-20:30) <b>Furnace 2</b> used the most.
                </Typography>
                <Stack spacing={1.3}>
                    {rows.map((r) => (
                        <Box key={r.n}>
                            <Stack direction="row" sx={{ justifyContent: "space-between", mb: .6 }}>
                                <Typography sx={{ fontSize: f - 2, color: "rgba(255,255,255,.8)" }}>{r.n}</Typography>
                                <Typography sx={{ fontSize: f - 2, color: "#9FE08C", fontWeight: 700 }}>
                                    {r.v.toLocaleString("en-IN")} kWh
                                </Typography>
                            </Stack>
                            <Box sx={{ height: bar, borderRadius: 4, bgcolor: "rgba(255,255,255,.08)" }}>
                                <Box sx={{ height: bar, width: r.w, borderRadius: 4, bgcolor: "#2E7D20" }} />
                            </Box>
                        </Box>
                    ))}
                </Stack>
                <Divider sx={{ my: 1.6, borderColor: "rgba(255,255,255,.08)" }} />
                <Typography sx={{ fontSize: 13.5, color: "rgba(255,255,255,.45)" }}>
                    Source: 3 tags · Shift A · 12 hours
                </Typography>
            </Box>
        </Box>
    );
}
